import React from 'react';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import './MultiSelectFilter.scss'

const animatedComponents = makeAnimated();

// Los estilos personalizados se trasladaron a MultiSelectFilter.scss

interface Option {
  value: any;
  label: string;
}

interface MultiSelectFilterProps {
  options: Option[];
  onChange: (selectedOptions: Option[]) => void;
  placeholder: string;
  value?: Option[];
}

const MultiSelectFilter: React.FC<MultiSelectFilterProps> = ({ options, onChange, placeholder, value }) => {
  const handleChange = (selectedOptions: any) => {
    onChange(selectedOptions);
  };

  return (
    <Select
      components={animatedComponents}
      isMulti
      options={options}
      onChange={handleChange}
      value={value}
      placeholder={placeholder}
      className="MultiSelectFilter-mediopunto"
      classNamePrefix="react-select"
      noOptionsMessage={() => 'No hay opciones'}
      // styles eliminados, ahora todo está en el SCSS
    />
  );
};

export default MultiSelectFilter;
